import React, { useEffect } from 'react'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'

import { PersistGate } from 'redux-persist/integration/react'
import { MsalProvider } from '@azure/msal-react'

import store, { persistor } from './appRedux/store'
import Alert from './components/Alert/alert'
import Loading from './components/Loading/loading'
import Routes from './routes/routes'
import { getHealth } from './services/api'
import './config/ReactotronConfig'

import 'assets/vendors/style'
import 'styles/wieldy.less'
import './app.css'

const NextApp = ({ msalInstance }) => {
  useEffect(() => {
    const healthCheck = async () => {
      try {
        await getHealth()
      } catch (error) {
        console.log('ERROR (HealthCheck): ', error)
      }
    }

    const intervalId = setInterval(healthCheck, 60000)
    return () => {
      clearInterval(intervalId)
    }
  }, [])

  return (
    <MsalProvider instance={msalInstance} store={store}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <BrowserRouter>
            <Routes />
            <Loading />
            <Alert />
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </MsalProvider>
  )
}

export default NextApp
